import { useState, useEffect } from 'react';
//import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import Dialog from '../Controls/Dialog'; // Fixed import path
import CustomButton from '../Controls/CustomButton'; // Fixed import path

export default function ConfirmDlg(props) {
   //title,content,open,onResponse,noLabel,yesLabel
   const [isOpen, setOpen] = useState(props.open);
   if (!props.hasOwnProperty("title"))
      console.error('ConfirmDlg requires a title property');
   if (!props.hasOwnProperty("content"))
      console.error('ConfirmDlg requires a content property');
   if (!props.hasOwnProperty("open"))
      console.error('ConfirmDlg requires an open property which should be a state variable used to determine if the dialog is open (ie default to false)');
   if (!props.hasOwnProperty("onResponse"))
      console.error('ConfirmDlg requires an onResponse property to receive the users choice');

   useEffect(e => {
      setOpen(props.open);
   }, [props.open])

   const handleClose = () => {
      setOpen(false);
      if (props.onResponse)
         props.onResponse(0);
   };
   const handleResponse = (yes) => {
      if (props.onResponse)
         props.onResponse(yes);
   }

   return (
      <div>
         <Dialog
            open={isOpen}
            onClose={handleClose}
            title={props.title}
            actions={
               <>
                  <CustomButton onClick={e => handleResponse(0)} color="secondary" variant="outlined">
                     {props.noLabel || "No"}
                  </CustomButton>
                  <CustomButton onClick={e => handleResponse(1)} color="primary" autoFocus variant="contained">
                     {props.yesLabel || "Yes"}
                  </CustomButton>
               </>
            }
         >
            {props.content}
         </Dialog>
      </div>
   );
}
